<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex
          d-flex
          sx12
          sm6
          md3
          v-for="(card, index) in actionCards"
          v-bind:key="index"
        >
          <v-card dark class="card-frame">
            <v-card-title primary class="title">{{
              card.title | phrasemap
            }}</v-card-title>
            <v-card-text>
              <div class="text-center avatar-space">
                <v-avatar color="primary" size="67">
                  <v-icon large dark>{{ card.icon }}</v-icon>
                </v-avatar>
              </div>
              <div class="text-justify">
                {{ card.desc | phrasemap }}
              </div>
            </v-card-text>
            <v-card-actions class="card-actions">
              <v-btn
                :loading="card.loading"
                @click="processCard(card)"
                color="green"
                block
                >{{ card.buttonName | phrasemap }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { sync } from "vuex-pathify";
import helper from "./helper";
export default {
  props: {
    module: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    actionCards: [],
    loading: false,
    sdialog: false,
    sdialog: false,
  }),
  computed: {
    fullPage: sync("dialog/dialogIsFullPage"),
    dialog: sync("dialogOpen"),
  },
  methods: {
    async processCard(card) {
      console.log("Processing CMD = " + card.action);
      let index = this.actionCards.findIndex((x) => x.action === card.action);
      this.actionCards[index].loading = true;
      let popupText = "";
      let popupTitle = "Success";
      let syncAction = "";
      switch (card.action) {
        case "campaign_sync":
          syncAction = "campaign_sync";
          console.log("In the campaign sync case statement");
          popupText =
            "Campaign synchronization completed. Results are available in the campaign table.";
          break;
        case "template_sync":
          syncAction = "template_sync";
          popupText =
            "Template synchronization completed. Results are available in the template table.";
          break;
        case "campaign_create":
          this.showCampaignCreate = true;
          syncAction = null;
          this.sdialog = true;
          popupText =
            "Campaign created. Campaign information available in the campaign table.";
        default:
          break;
      }
      if (syncAction !== null) {
        let syncOperation = await helper.mailChimpSync(syncAction);
        this.actionCards[index].loading = false;
        this.$root.$confirm(popupTitle, popupText, {
          color: "green",
          nocancel: true,
          ok: "OK",
        });
      }
    },
    async campaignSync() {},
  },
  beforeMount() {
    if (this.module === "CRM") {
      console.log("Setting up  workflows for the CRM module");
      this.actionCards = [
        {
          title: "wCampaign",
          icon: "mdi-rocket-launch",
          desc:
            "The campaign worflow allows you to create and manage email marketing campaigns.",
          buttonName: "Create",
          loading: false,
          action: "campaign_create"
        },
        {
          title: "Campaigns",
          icon: "mdi-rocket-launch",
          desc:
            "The campaign worflow allows you to create and manage email marketing campaigns.",
          buttonName: "Edit",
          loading: false,
        },
        {
          title: "Campaigns",
          icon: "mdi-rocket-launch",
          desc:
            "The campaign worflow allows you to create and manage email marketing campaigns.",
          buttonName: "Synchronize",
          action: "campaign_sync",
          loading: false,
        },
        {
          title: "Templates",
          icon: "mdi-toy-brick-plus",
          desc:
            "Templates allow s synchronization with email templates created in the email marketing software. These templates can only be viewed and synchronized in Cortex.",
          buttonName: "Synchronize",
          action: "template_sync",
          loading: false,
        },
      ];
    }
  },
};
</script>
<style scoped>
.avatar-space {
  padding-bottom: 10px;
}
.card-frame {
  position: relative;
  padding-bottom: 40px;
}
.card-actions {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
